<template>
  <Modal
    v-model="visible"
    :title="title"
    :width="90"
  >
    <div class="wrap" :style="{ height: `${clientHeight - 350}px` }">
      <img v-if="item" class="image" :src="item.previewURL">
    </div>
    <template v-slot:footer>
      <Button type="text" :disabled="index === 0" @click="handlePre">上一张</Button>
      <span class="page">{{ `${index + 1} / ${list.length}` }}</span>
      <Button type="text" :disabled="index + 1 === list.length" @click="handleNext">下一张</Button>
      <Button v-if="deleteBtn" type="error" @click="handleDel">删除</Button>
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'image-view',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    deleteBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false,
      index: -1,
      clientHeight: 0
    }
  },
  computed: {
    item () {
      return this.list[this.index]
    }
  },
  methods: {
    open (index) {
      this.clientHeight = document.body.clientHeight
      this.visible = true
      this.index = index
    },
    handleDel () {
      this.$emit('on-image-remove', this.index)
      if (!this.list[this.index]) {
        this.index--
        if (!this.list[this.index]) {
          this.visible = false
        }
      }
    },
    handlePre () {
      this.index--
    },
    handleNext () {
      this.index++
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  overflow: auto;
}
.image {
  display: block;
  width: 100%;
}
.page {
  margin: 0 12px;
}
</style>